import { createAsyncAction } from 'typesafe-actions';
import { AccommodationOfferPriceCalculationModel } from '../../api/interfaces';

const modelName = 'accommodationOfferPriceCalculation';

export const calculatePriceAsyncAction = createAsyncAction<'CANCEL_REQUEST', 'CANCEL_SUCCESS', 'CANCEL_FAILURE'>(
    `${modelName}/CALCULATE_PRICE_REQUEST` as 'CANCEL_REQUEST',
    `${modelName}/CALCULATE_PRICE_SUCCESS` as 'CANCEL_SUCCESS',
    `${modelName}/CALCULATE_PRICE_FAILURE` as 'CANCEL_FAILURE'
)<void, AccommodationOfferPriceCalculationModel, Error>();